export const ENDION_CHATBOT_UPDATE_CONTEXT_EVENT_NAME = 'endion-chatbot-update-context';
export const ENDION_CHATBOT_READY_EVENT_NAME = 'endion-chatbot-ready';
export const ENDION_CHATBOT_UPDATE_STATE_EVENT_NAME = 'endion-chatbot-update-state';
